import { type AnyAction } from 'redux';
import { defaultTo } from 'lodash';
import {
    RESET_REQUEST,
    SEND_REQUEST,
    SEND_REQUEST_FAIL,
    SEND_REQUEST_SUCCESS
} from '../actions/actionTypes/request';
import { LOGOUT } from '../actions/actionTypes/user';
import { type RequestState } from '../types';

const initialState: RequestState = {};
const defaultMeta = { loading: false, loaded: false, lastUpdated: null, error: null };

export const request = (state = initialState, action: AnyAction): RequestState => {
    const { type, meta = {} } = action;
    const { requestId, timestamp } = action.request || {};
    const { error } = meta;

    if (!requestId) {
        if (type === LOGOUT) {
            return initialState;
        }
        return state;
    }

    switch (type) {
        case SEND_REQUEST: {
            return {
                ...state,
                [requestId]: {
                    ...defaultTo(state[requestId], defaultMeta),
                    error: null,
                    loading: true,
                    loaded: false
                }
            };
        }
        case SEND_REQUEST_SUCCESS: {
            return {
                ...state,
                [requestId]: {
                    ...defaultTo(state[requestId], defaultMeta),
                    error: null,
                    lastUpdated: timestamp,
                    loading: false,
                    loaded: true
                }
            };
        }
        case SEND_REQUEST_FAIL: {
            return {
                ...state,
                [requestId]: {
                    ...defaultTo(state[requestId], defaultMeta),
                    loading: false,
                    loaded: false,
                    error
                }
            };
        }
        case RESET_REQUEST: {
            return {
                ...state,
                [requestId]: undefined
            };
        }
        case LOGOUT:
            return initialState;

        default: {
            return state;
        }
    }
};
